module.exports = __webpack_public_path__ + "static/img/robot_wait.ca03f0ce.svg";